export interface Messages {
  messages?: { errorMessage: string; errorCode: string }[];
}

export enum ErrorCode {
  PROMO_CODE_INVALID = 'PromoCodeInvalid',
  TURBO_QUOTE_NOT_POSSIBLE = 'TurboQuoteNotPossible',
  NOT_EXISTING_TRANSLATION = 'NotExistingTranslation',
  PAYMENT_FAILED = 'PaymentFailed',
  INCORRECT_JOB_ID = 'JobNotFound',
  INCORRECT_INVOICE_EMAIL = 'IncorrectInvoiceEmail',
  NO_FILE_ATTACHED = 'NoFileAttached',
  CONNECTION_PROBLEMS = 'ConnectionProblems',
  JOB_ALREADY_INVOICED = 'JobAlreadyInvoiced',
  JOB_ALREADY_PAID = 'JobAlreadyPaid',
  JOB_NOT_INVOICEABLE = 'JobNotInvoiceable',
  PROVIDER_DOESNT_HAVE_JOBS_TO_INVOICE = 'ProviderDoesntHaveJobsToInvoice',
}
